
        import i18n from 'i18n';
        import flattenObject from 'util/flattenObject';
    
            import nsf5e76ec3afe92cabc296d99a657d4bd9en from './en.yaml'
            i18n.addResourceBundle('en', 'f5e76ec3afe92cabc296d99a657d4bd9', flattenObject(nsf5e76ec3afe92cabc296d99a657d4bd9en), true, true);
        
        export default 'f5e76ec3afe92cabc296d99a657d4bd9';
    